export const ProdMainTestAccountFeatureFlag = (accountId: string): boolean => {
  // Returns true if domain is localhost, development or test, or the domain is prod and the accountId is the main test account
  const hostname = window.location.hostname
  const isLocalhost = hostname === 'localhost'
  const isDevelopment = hostname === 'app-dev.qualisflow.com'
  const isTest = hostname === 'app-test.qualisflow.com'
  const isProduction = hostname === 'app.qualisflow.com'
  const isMainTestAccount = accountId === '269842d3-cfea-47e8-8678-dc27a903f1d7'

  return (
    isLocalhost ||
    isDevelopment ||
    isTest ||
    (isProduction && isMainTestAccount)
  )
}
